import { Bell,ChevronUp,ChevronDown } from "lucide-react";


export const AlertsPanel = ({ alerts, isExpanded, onToggle }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <button 
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-2">
          <Bell size={18} className="text-orange-500" />
          <h3 className="text-sm font-semibold text-gray-800">Alerts</h3>
          {alerts.length > 0 && (
            <span className="px-2 py-0.5 bg-orange-100 text-orange-700 text-xs rounded-full font-medium">
              {alerts.length}
            </span>
          )}
        </div>
        {isExpanded ? <ChevronUp size={18} className="text-gray-400" /> : <ChevronDown size={18} className="text-gray-400" />}
      </button>
      {isExpanded && (
        <div className="px-4 pb-4 space-y-2 max-h-64 overflow-y-auto">
          {alerts.length > 0 ? (
            alerts.map((alert) => (
              <div 
                key={alert.id}
                className={`text-xs text-gray-700 py-2.5 px-3 rounded border-l-4 ${
                  alert.severity === 'high' 
                    ? 'bg-red-50 border-red-500' 
                    : alert.severity === 'medium'
                    ? 'bg-orange-50 border-orange-500'
                    : 'bg-yellow-50 border-yellow-500'
                }`}
              >
                <div className="flex items-start justify-between gap-2">
                  <span className="flex-1">{alert.message}</span>
                  {alert.time && (
                    <span className="text-xs text-gray-500 whitespace-nowrap">{alert.time}</span>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="text-xs text-gray-500 text-center py-4">
              No alerts at this time
            </div>
          )}
        </div>
      )}
    </div>
  );
};

